module.exports = __webpack_public_path__ + "img/icono clinica2 opa.ae8247d7.png";